// @flow

import React from 'react';
import { DateRangePicker } from 'react-dates';

// $FlowFixMe
import 'react-dates/lib/css/_datepicker.css';
import { colors } from 'seedling/constants';
import { filterObjectProperties } from 'seedling/utils/object_utils';
import { injectGlobalCalendarStyles } from 'seedling/components/date_picker';

type Props = {
  focusOnMount: boolean,
  onFocusChange: boolean => void,
  enableOutsideDays: boolean,
  isOutsideRange: () => boolean,
  numberOfMonths: number,
  placeholder: string,
  displayFormat: string,
  initialStartDate: Moment,
  initialEndDate: Moment,
  onChange: (Moment | null, Moment | null) => void,
};

type Moment = any;
type InputField = any;

type State = {
  focused: boolean,
  startDate: Moment,
  endDate: Moment,
  focusedInput: InputField,
  startDateId: string,
  endDateId: string,
};

export default class DatePicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const uuid = Date.now();

    this.state = {
      focused: props.focusOnMount,
      startDate: props.initialStartDate,
      endDate: props.initialEndDate,
      focusedInput: null,
      startDateId: `start_date_input_id_${uuid}`,
      endDateId: `end_date_input_id_${uuid}`,
    };
  }

  static defaultProps = {
    focusOnMount: false,
    onFocusChange: () => {},
    enableOutsideDays: true,
    isOutsideRange: () => false,
    numberOfMonths: 1,
    placeholder: 'Date',
    displayFormat: 'MM/DD/YYYY',
    onChange: () => {},
  };

  onFocusChange = (focused: boolean) => {
    this.setState({ focused }, () => {
      this.props.onFocusChange(focused);
    });
  };

  render() {
    // we want to be able to pass props to our Datepicker wrapper component
    // without them being passed automatically to the underlying SingleDatePicker
    // component, so we filter only allowed props.
    const allowedPropTypes = Object.keys(DateRangePicker.propTypes);
    const allowedProps = filterObjectProperties(this.props, allowedPropTypes);

    return (
      <DateRangePicker
        {...allowedProps}
        startDateId={this.state.startDateId}
        endDateId={this.state.endDateId}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onDatesChange={({ startDate, endDate }) => {
          this.setState({ startDate, endDate });
          this.props.onChange(startDate, endDate);
        }}
        focused={this.state.focused}
        focusedInput={this.state.focusedInput}
        onFocusChange={focusedInput => this.setState({ focusedInput })}
      />
    );
  }
}

injectGlobalCalendarStyles(
  'DateRangePicker',
  `
  .DateRangePickerInput__arrow {
    display: none;
  }

  .CalendarDay--hovered-span,
  .CalendarDay--after-hovered-start,
  .CalendarDay--selected-span,
  .CalendarDay--selected-span:active {
    background: ${colors.babyBlue};
    border: 1px solid #e4e7e7;
    color: black;
  }

  .CalendarDay--selected-start,
  .CalendarDay--selected-end,
  .CalendarDay--selected-span.CalendarDay--hovered {
    background: ${colors.lightBlue};
    border: 1px solid #e4e7e7;
    color: black;
  }

  .CalendarDay--selected-start,
  .CalendarDay--selected-end,
  .CalendarDay--hovered-span {
    .CalendarDay__button:focus {
      background: ${colors.lightBlue};
    }
  }

  /* Next three blocks are used to handle line highlight between inputs */
  .DateRangePickerInput > .DateInput--open-down:first-of-type {
    border-right: 0;
  }

  .DateInput--with-caret ~ .DateInput--open-down {
    border-left: 0;
  }

  .DateRangePickerInput > .DateInput--with-caret:first-of-type {
    border-right: 1px solid ${colors.mediumGreenhouseGreen};
  }
`
);
